module.exports = __webpack_public_path__ + "img/rwe-logo-revised.b1053a32.svg";